import { render, staticRenderFns } from "./artistInfo.vue?vue&type=template&id=0107bc4c&scoped=true&"
import script from "./artistInfo.vue?vue&type=script&lang=js&"
export * from "./artistInfo.vue?vue&type=script&lang=js&"
import style0 from "./artistInfo.vue?vue&type=style&index=0&id=0107bc4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107bc4c",
  null
  
)

/* custom blocks */
import block0 from "./artistInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports